import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import gridFluidDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-fluid-do.png";
import gridFluidDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-fluid-dont.png";
import gridFixedDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-fixed-do.png";
import gridFixedDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-fixed-dont.png";
import gridBreakpointSpanDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-span-do.png";
import gridBreakpointSpanDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-span-dont.png";
import gridBreakpointWidthDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-width-do.png";
import gridBreakpointWidthDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-width-dont.png";
import gridBreakpointChangeDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-change-do.png";
import gridBreakpointChangeDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-change-dont.png";
import gridBreakpointDesignsDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-designs-do.png";
import gridBreakpointDesignsDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-breakpoint-designs-dont.png";
import gridAsideDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-aside-do.png";
import gridAsideDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-aside-dont.png";
import gridAlignFigmaDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-figma-do.png";
import gridAlignFigmaDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-figma-dont.png";
import gridAlignElementsDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-elements-do.png";
import gridAlignElementsDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-elements-dont.png";
import gridAlignColumnsDo from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-columns-do.png";
import gridAlignColumnsDont from "../../../../src/pages/foundations/grid-beta/applying-grid/_assets/grid-align-columns-dont.png";
import * as React from 'react';
export default {
  Link,
  SectionMessage,
  gridFluidDo,
  gridFluidDont,
  gridFixedDo,
  gridFixedDont,
  gridBreakpointSpanDo,
  gridBreakpointSpanDont,
  gridBreakpointWidthDo,
  gridBreakpointWidthDont,
  gridBreakpointChangeDo,
  gridBreakpointChangeDont,
  gridBreakpointDesignsDo,
  gridBreakpointDesignsDont,
  gridAsideDo,
  gridAsideDont,
  gridAlignFigmaDo,
  gridAlignFigmaDont,
  gridAlignElementsDo,
  gridAlignElementsDont,
  gridAlignColumnsDo,
  gridAlignColumnsDont,
  React
};